// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Zb72","list":"BalanceDue_list__BpbYU","listRow":"BalanceDue_listRow__3Qr4p","total":"BalanceDue_total__IDZUE"};